import React from 'react';
import moment from "moment";
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import menuLiveStatsIcon from '../../../../../../assets/images/icons/menu-live-stats-icon.svg'
import menuLiveVideoIcon from '../../../../../../assets/images/icons/menu-live-video-icon.svg'
import menuManualVideoIcon from '../../../../../../assets/images/icons/menu-manual-video-icon.svg'
class SessionListRender extends React.Component {
    render() {
        return (
            <ul className="nav-menu">
                {this.props.sessionList.map((sessionMonthList, index) =>
                    <li className="menu menu-session collapse-box" key={index}>
                        <Button style={{ paddingLeft: '5px', paddingRight: '10px' }}>
                            <span className="nav-text">{sessionMonthList.sessionMY} : ({sessionMonthList.count}-ses)</span>
                        </Button>
                        <ul className="sub-menu">
                            {sessionMonthList.sessions.map((session, ind) =>
                                <li key={ind}>
                                    <NavLink onClick={(e) => this.props.onHandleMenuClick(session)} style={{ paddingLeft: '10px', paddingRight: '0px', textTransform: 'initial', marginRight: '2px' }} to={`/app/user/session/${session.sessionId}`}>
                                        {session.sessionMode === 'live-video' ? <img src={menuLiveVideoIcon} alt='' /> : (session.sessionMode === 'manual-video-recording' ? <img src={menuManualVideoIcon} alt='' /> : <img src={menuLiveStatsIcon} alt='' />)}<span className="nav-tex pl-2">{moment(session.completionDateTs).format('Do')} at {moment(session.completionDateTs).format('h:mm:ss a')} </span>
                                    </NavLink>
                                </li>
                            )}
                        </ul>
                    </li>
                )}
            </ul>
        )
    }
}
export default SessionListRender;